<div class="chart-container relative flex items-center justify-center" [style.width.px]="width" [style.height.px]="height">
    <mat-label class="text-3xl font-bold mt-1">{{ percentage }}%</mat-label>
    <apx-chart class="w-full absolute text-xl font-bold text-gray-700"
        [series]="chartOptions.series"
        [chart]="chartOptions.chart"
        [labels]="chartOptions.labels"
        [responsive]="chartOptions.responsive"
        [colors]="chartOptions.colors"
        [tooltip]="chartOptions.tooltip"
        [states]="chartOptions.states"
        [plotOptions]="chartOptions.plotOptions"
    ></apx-chart>
</div>
